/* ============================================================
   OBEE EXTRACTS — Übersicht mit Filtern
   ============================================================ */
(function () {
  'use strict';
  var D = window.OBEE_STRAINS; if (!D) return;
  var root = document.getElementById('range'); if (!root) return;

  var grid    = root.querySelector('.range-grid');
  var countEl = root.querySelector('.range-count');
  var btns    = root.querySelectorAll('.filters button');
  var cards   = grid.querySelectorAll('.card');
  var active  = 'all';

  function apply() {
    var n = 0;
    Array.prototype.forEach.call(cards, function (c) {
      var ok = active === 'all' ||
               c.dataset.type === active ||
               (c.dataset.family || '').split(' ').indexOf(active) > -1;
      c.classList.toggle('hidden', !ok);
      if (ok) n++;
    });
    if (countEl) countEl.textContent = 'Showing ' + n + ' of ' + cards.length;
    Array.prototype.forEach.call(btns, function (b) {
      b.setAttribute('aria-pressed', b.dataset.f === active ? 'true' : 'false');
    });
  }

  Array.prototype.forEach.call(btns, function (b) {
    b.addEventListener('click', function () { active = b.dataset.f; apply(); });
  });

  /* Eine Karte führt in die Großansicht, weil dort die Angaben aus dem
     Datenblatt stehen — Aromaprofil, Genetik, Züchter. Die Bühne zeigt
     nur den Ausschnitt. */
  Array.prototype.forEach.call(cards, function (c) {
    c.addEventListener('click', function () {
      var i = parseInt(c.dataset.i, 10);
      if (window.OBEE_GEN2) window.OBEE_GEN2(i);
      else if (window.OBEE_LOAD) window.OBEE_LOAD(i);
    });
  });

  apply();
})();
